<script>

    export let size = '128x128'
    export let src = null
    export let alt = 'brand'
    export let isRounded = false

</script>

<figure class="image is-{size}" class:is-rounded={isRounded}>
    <img src={src} alt={alt}>
</figure>